import {
  PlusCircle,
  DotsIcon,
  EditIcon,
  DeleteIcon,
  PlusIcon,
  CloseIcon,
  UserIcon,
  ListIcon,
  SearchIcon,
  ShareIcon,
  CircleFillIcon,
  CircleIcon,
  CircleIcon2,
  TrashIcon,
  MinusIcon,
  SunIcon,
  MoonIcon,
  GridIcon,
  BellIcon,
  PhoneIcon1,
  PhoneIcon2,
  HomeIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowTopIcon,
  ArrowBottomIcon,
  ArrowRightIcon1,
  ArrowLeftIcon1,
  TickIcon,
  SettingIcon,
  ManagerIcon,
  EyeIcon,
  EnvelopeIcon,
  UsersIcon,
  HandIcon,
  ShoppingIcon,
  BasketIcon,
  ListIcon1,
  UserListIcon,
  StopIcon,
  TelegramIcon,
  LockIcon,
  TickIcon1
} from "../components/kits/Icons.tsx";
import ColorSchema from "../components/kits/Color";
export default function Icons() {
  return (
    <div>
      <div className="d-flex justify-content-evenly p-5">
        <PlusCircle color={ColorSchema.red_custom} />
        <DotsIcon containerIconClassName="m-3" />
        <EditIcon containerIconClassName="m-3" />
        <DeleteIcon color={ColorSchema.danger_custom} />
      </div>
      <div className="d-flex flex-wrap p-5">
        <PlusIcon containerIconClassName="m-3" />
        <MinusIcon containerIconClassName="m-3" />
        <CloseIcon containerIconClassName="m-3" />
        <UserIcon containerIconClassName="m-3" />
        <ListIcon containerIconClassName="m-3" />
        <SearchIcon containerIconClassName="m-3" />
        <ShareIcon
          containerIconClassName="m-3  border border-primary"
          iconClassName=""
          color={ColorSchema.blue_custom}
          width={40}
          height={40}
          style={{ borderRadius: 10 }}
        />
        <CircleFillIcon containerIconClassName="m-3" />
        <CircleIcon containerIconClassName="m-3" />
        <CircleIcon2 containerIconClassName="m-3" />
        <TrashIcon containerIconClassName="m-3" />
        <SunIcon containerIconClassName="m-3" />
        <MoonIcon containerIconClassName="m-3" />
        <GridIcon containerIconClassName="m-3" />
        <BellIcon containerIconClassName="m-3" />
        <PhoneIcon1 containerIconClassName="m-3" />
        <PhoneIcon2 containerIconClassName="m-3" />
        <HomeIcon containerIconClassName="m-3" />
        <ArrowTopIcon containerIconClassName="m-3" />
        <ArrowBottomIcon containerIconClassName="m-3" />
        <ArrowRightIcon containerIconClassName="m-3" />
        <ArrowLeftIcon containerIconClassName="m-3" />
        <ArrowRightIcon1 containerIconClassName="m-3" />
        <ArrowLeftIcon1 containerIconClassName="m-3" />
        <TickIcon containerIconClassName="m-3" />
        <TickIcon1 containerIconClassName="m-3" />
        <SettingIcon containerIconClassName="m-3" />
        <ManagerIcon containerIconClassName="m-3" />
        <EyeIcon containerIconClassName="m-3" />
        <EnvelopeIcon containerIconClassName="m-3" />
        <UsersIcon containerIconClassName="m-3" />
        <HandIcon containerIconClassName="m-3" />
        <ShoppingIcon containerIconClassName="m-3" />
        <BasketIcon containerIconClassName="m-3" />
        <ListIcon1 containerIconClassName="m-3" />
        <UserListIcon containerIconClassName="m-3" />
        <StopIcon containerIconClassName="m-3" />
        <TelegramIcon containerIconClassName="m-3" />
        <LockIcon containerIconClassName="m-3" />
      </div>
    </div>
  );
}
